/** Sentinel filePath for pinned developer/team repo context (not shown in generic Notes). */
export const DEVELOPER_CONTEXT_FILE_PATH = "__renderrepo__/developer-context";

export function isInternalRepoNote(note) {
  const path = note?.filePath;
  return typeof path === "string" && path.startsWith("__renderrepo__/");
}
